import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { ApiError, apiClient, storePath } from '@/lib/api-client';
import type { StoreListing, StorePlatform, UpsertListingBody } from '@/types/store';

import { storeKeys } from './store-keys';

export interface UpsertListingVars {
  platform: StorePlatform;
  locale: string;
  body: UpsertListingBody;
}

/** PUT …/listings/:platform/:locale — save the draft copy (partial merge). */
export function useUpsertListing(): UseMutationResult<StoreListing, ApiError, UpsertListingVars> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ platform, locale, body }) =>
      apiClient.put<StoreListing>(
        storePath(`/listings/${platform}/${encodeURIComponent(locale)}`),
        body,
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: storeKeys.all });
    },
  });
}
